import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { MestradoComponent } from "./mestrado.component";
import { SharedModule } from "app/shared/shared.module";
import { MestradoService } from "./service/mestrado.service";
import { SharedPosGraduacaoModule } from "../shared/shared-pos-graduacao.module";
import { DetalhesCursoModule } from "./detalhe-curso/detalhe-curso.module";



@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        SharedPosGraduacaoModule,
        DetalhesCursoModule
    ],
    declarations: [
        MestradoComponent,
    ],
   
    exports: [
        MestradoComponent
    ],
    providers: [
        MestradoService
    ]
})

export class MestradoModule {}